export default __webpack_public_path__ + "static/media/Suction_Start.c9dca1d6.jpg";